@switch (state().status) {
  @case ('loading') {
    <div class="wishlist-skeleton" aria-busy="true">
      @for (cell of [1, 2, 3, 4]; track cell) {
        <div class="wishlist-skeleton__card">
          <span class="wishlist-skeleton__image"></span>
          <span class="wishlist-skeleton__line wishlist-skeleton__line--title"></span>
          <span class="wishlist-skeleton__line wishlist-skeleton__line--meta"></span>
        </div>
      }
    </div>
  }

  @case ('error') {
    <div class="wishlist-error" role="alert">
      <p class="wishlist-error__text">{{ copy.LOAD_ERROR }}</p>
      <app-button variant="secondary" size="sm" (click)="retry()">{{ retryLabel }}</app-button>
    </div>
  }

  @case ('loaded') {
    @if (total() === 0) {
      <div class="wishlist-empty">
        <img ngSrc="images/logo/comunity.png" width="450" height="512" alt="" class="wishlist-empty__mascot" />
        <p class="wishlist-empty__title">{{ copy.EMPTY_TITLE }}</p>
        <p class="wishlist-empty__text">{{ copy.EMPTY_TEXT }}</p>
        <a routerLink="/tienda" class="wishlist-empty__cta">
          <app-icon [icon]="heartIcon" [size]="16" />
          {{ tabCopy.EMPTY_CTA }}
        </a>
      </div>
    } @else {
      <div class="wishlist-toolbar">
        <span class="wishlist-toolbar__count">{{ countLabel() }}</span>

        <div class="wishlist-toolbar__actions">
          <app-page-size-select [value]="perPage()" (valueChange)="onPageSizeChange($event)" />

          <app-sort-dropdown
            [options]="sortOptions"
            [value]="sortKey()"
            [placeholder]="tabCopy.SORT_PLACEHOLDER"
            (valueChange)="onSortChange($event)"
          />

          <div class="wishlist-toolbar__view-toggle" role="radiogroup" [attr.aria-label]="tabCopy.VIEW_LABEL">
            <button
              class="wishlist-toolbar__view-btn"
              [class.wishlist-toolbar__view-btn--active]="viewMode() === 'grid'"
              type="button"
              role="radio"
              [attr.aria-checked]="viewMode() === 'grid'"
              [attr.aria-label]="tabCopy.VIEW_GRID"
              (click)="viewMode.set('grid')"
            >
              <app-icon [icon]="gridIcon" [size]="18" />
            </button>
            <button
              class="wishlist-toolbar__view-btn"
              [class.wishlist-toolbar__view-btn--active]="viewMode() === 'list'"
              type="button"
              role="radio"
              [attr.aria-checked]="viewMode() === 'list'"
              [attr.aria-label]="tabCopy.VIEW_LIST"
              (click)="viewMode.set('list')"
            >
              <app-icon [icon]="listIcon" [size]="18" />
            </button>
          </div>
        </div>
      </div>

      <div class="wishlist-grid" [class.wishlist-grid--list]="viewMode() === 'list'">
        @for (entry of paginated(); track entry.product.id) {
          <div class="wishlist-item" [class.wishlist-item--list]="viewMode() === 'list'">
            <app-product-card
              [product]="entry.product"
              [viewMode]="viewMode()"
              variant="wishlist"
              (addToCart)="onAddToCart($event)"
              (zoomOpen)="onZoomOpen($event)"
              (notifyRequest)="onNotify($event)"
              (notifyCancel)="onNotifyCancel($event)"
              (cardClick)="navigateToProduct($event)"
              (reserveClick)="onReserve($event)"
            />
            @if (addedLabel(entry); as added) {
              <p class="wishlist-item__date">{{ added }}</p>
            }
          </div>
        }
      </div>

      @if (totalPages() > 1) {
        <div class="wishlist-pagination">
          <app-pagination [currentPage]="page()" [totalPages]="totalPages()" (pageChange)="onPageChange($event)" />
        </div>
      }
    }
  }
}

@if (zoomProduct(); as product) {
  <app-product-zoom-modal
    [product]="product"
    [notifyActive]="zoomNotifyActive()"
    (close)="onZoomClose()"
    (addToCart)="onZoomAddToCart($event)"
    (reserveRequest)="onZoomReserve($event)"
    (notifyRequest)="onNotify($event)"
    (notifyCancel)="onNotifyCancel($event)"
    (viewDetails)="onZoomViewDetails($event)"
  />
}
